import { PostHogProvider, usePostHog } from "@-/com.npmjs.posthog-react-native";
import { usePathname } from "@-/com.npmjs.expo-router";
import { useAuthSession } from "@-/dev.improve.haniverse.lib.auth.client";
import { PostHogTrackingReadyContext } from "#feature-flags";
import { getPostHog } from "#get-posthog";
import { PostHogIdentity } from "#posthog-identity";
import { useContext, useEffect, type PropsWithChildren } from "react";

function PostHogScreenTracking() {
  const posthog = usePostHog();
  const pathname = usePathname();
  const identityReady = useContext(PostHogTrackingReadyContext);
  useEffect(() => {
    if (identityReady) {
      void posthog.screen(pathname);
    }
  }, [identityReady, pathname, posthog]);
  return null;
}

export function AppPostHogProvider({ children }: PropsWithChildren) {
  const session = useAuthSession();
  return (
    <PostHogProvider autocapture={false} client={getPostHog()}>
      <PostHogIdentity session={session}>
        <PostHogScreenTracking />
        {children}
      </PostHogIdentity>
    </PostHogProvider>
  );
}
